import React from 'react';
import propTypes from 'prop-types';
import Styles from './Homepage.module.scss';
import DropZone from '@hobs/components/DropZone';

const Homepage = ({ informationText, attachments }) => {
  return (
    <div className={Styles['homepage-wrapper']}>
      <p className={Styles['section-title']}>Home</p>
      <div className={Styles['content-box']}>
        <div className={Styles['content']}>
          <div
            dangerouslySetInnerHTML={{
              __html: informationText
            }}
          />
        </div>
      </div>
      <p className={Styles['section-title']}>Attachments</p>
      <DropZone value={attachments} disabled={true} />
    </div>
  );
};

Homepage.propTypes = {
  children: propTypes.oneOfType([
    propTypes.object,
    propTypes.array,
    propTypes.string
  ])
};

export default Homepage;
